var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { MasterService } from '@app/utility/master.service';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '@app/auth.service';
import { timer } from 'rxjs/observable/timer';
import { environment } from '@env/environment';
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["Company"] = 1] = "Company";
    CustomerType[CustomerType["Person"] = 2] = "Person";
})(CustomerType || (CustomerType = {}));
;
var TicketListComponent = /** @class */ (function () {
    function TicketListComponent(Util, Api, MasterService, Auth, FB) {
        this.Util = Util;
        this.Api = Api;
        this.MasterService = MasterService;
        this.Auth = Auth;
        this.FB = FB;
        this.TotalFileSize = 0;
        this.Editable = true;
        this.DataSource1 = [];
        this.DataSource2 = [];
        this.FileList = [];
        this.OTPRefCode = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
    }
    // @HostListener('window:keyup', ['$event'])
    // handleKeyboardEvent(event: KeyboardEvent) {
    //   if (event.key == "Enter") {
    //     //alert(event.target.id);
    //     let t: any = event.target;
    //     if (t.id == "Search1")
    //       this.CreateTable1();
    //     else if (t.id == "Search2")
    //       this.CreateTable2();
    //   }
    // }
    TicketListComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, thisTs, _d, TableDocs;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile"))];
                    case 1:
                        _a.Profile = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.Auth.GetRole(this.Profile[0]["dpa_roleid"])];
                    case 2:
                        _b.Role = _e.sent();
                        this.Role = this.Role[0];
                        _c = this;
                        return [4 /*yield*/, this.Api.get("master", "approvalStatus")];
                    case 3:
                        _c.masterStatus = _e.sent();
                        if (this.Role.dpa_access_approve) {
                            $('#SuperFilter').removeClass("hidden");
                            $('#OfficerFilter').addClass("hidden");
                            $('#Table2Title').html('รายการที่อนุมัติแล้ว');
                        }
                        else {
                            $('#SuperFilter').addClass("hidden");
                            $('#OfficerFilter').removeClass("hidden");
                            $('#Table2Title').html('รายการที่รออนุมัติ / อนุมัติแล้ว');
                        }
                        return [4 /*yield*/, this.CreateTable1()];
                    case 4:
                        _e.sent();
                        return [4 /*yield*/, this.CreateTable2()];
                    case 5:
                        _e.sent();
                        $('#dlgDetails').on('shown.bs.modal', function () {
                            $('#txtTicketID').trigger('focus');
                        });
                        thisTs = this;
                        this.AcceptExtension = environment.AcceptUploadFileExtension;
                        _d = this;
                        return [4 /*yield*/, this.MasterService.GetMaxUploadFileSize()];
                    case 6:
                        _d.MaxTotalSizeMB = _e.sent();
                        TableDocs = $('#TableDocs');
                        TableDocs.on('click', 'tbody tr td [role=view]', function () {
                            thisTs.ViewDoc($(this).attr('url'), $(this).attr('filename'));
                        });
                        TableDocs.on('click', 'tbody tr td [role=delete]', function () {
                            thisTs.DeleteDoc($(this).attr('filename'), $(this).attr('annotationid'));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.onSearch1Change = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!($("#Search1").val().length == 13)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.CreateTable1()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.CreateTable1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, SearchFirstName, SearchLastName, SearchIdCard, SearchPassport, QueryString, _a, SearchText, _b, Table1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        thisTs = this;
                        if (!this.Role.dpa_access_approve) return [3 /*break*/, 2];
                        SearchFirstName = $("#SearchFirstName").val();
                        SearchLastName = $("#SearchLastName").val();
                        SearchIdCard = $("#SearchIdCard").val();
                        SearchPassport = $("#SearchPassport").val();
                        QueryString = "approvalstatuscode=02";
                        if (SearchFirstName != "")
                            QueryString += "&firstname=" + SearchFirstName;
                        if (SearchLastName != "")
                            QueryString += "&lastname=" + SearchLastName;
                        if (SearchIdCard != "")
                            QueryString += "&idcard=" + SearchIdCard;
                        if (SearchPassport != "")
                            QueryString += "&passportid=" + SearchPassport;
                        _a = this;
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", QueryString)];
                    case 1:
                        _a.DataSource1 = _c.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        SearchText = $("#Search1").val();
                        if (!(SearchText == null || SearchText == "")) return [3 /*break*/, 3];
                        this.DataSource1 = [];
                        return [3 /*break*/, 5];
                    case 3:
                        _b = this;
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=01")];
                    case 4:
                        _b.DataSource1 = _c.sent();
                        _c.label = 5;
                    case 5:
                        Table1 = $('#Table1').DataTable();
                        Table1.destroy();
                        Table1 = $('#Table1').DataTable({
                            "data": thisTs.DataSource1,
                            "columns": [
                                { "data": "dpa_name" },
                                {
                                    "data": "dpa_contactid",
                                    "render": function (data, type, row) {
                                        return row.dpa_authorizedperson == null ? row.dpa_contactidname : row.dpa_authorizedperson;
                                    }
                                },
                                {
                                    "data": "dpa_contactidname",
                                    "render": function (data, type, row) {
                                        return row.dpa_authorizedperson == null ? "" : row.dpa_contactidname;
                                    }
                                },
                                {
                                    "data": "dpa_originalsource",
                                    "render": function (data, type, row) {
                                        if (row.dpa_originalsource == 1)
                                            return "Customer Portal";
                                        else
                                            return "Agent Bank";
                                    }
                                },
                                {
                                    "data": "dpa_approvalstatusidname",
                                    "render": function (data, type, row) {
                                        return row.dpa_approvalstatusidname;
                                    }
                                },
                                {
                                    "data": "dpa_submitdate",
                                    "render": function (data, type, row) {
                                        if (row.dpa_submitdate != null) {
                                            var d = new Date(row.dpa_submitdate);
                                            return '<span class="sr-only">' + d.getFullYear().toString() + (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1).toString() + (d.getDate() < 10 ? "0" : "") + d.getDate().toString() + '</span>' +
                                                thisTs.Util.ConvertToBE(d.getDate().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString());
                                        }
                                        else
                                            return "";
                                    }
                                }
                            ],
                            "language": {
                                "lengthMenu": "แสดง _MENU_ รายการ/หน้า",
                                "zeroRecords": "ไม่มีข้อมูล",
                                "search": "ค้นหา:",
                                "info": "แสดงรายการที่ _START_ - _END_ จากทั้งหมด _TOTAL_ รายการ",
                                "infoEmpty": "ไม่มีข้อมูล",
                                "infoFiltered": "(ค้นหาจากทั้งหมด _MAX_ รายการ)",
                                "paginate": {
                                    "previous": "<",
                                    "first": "<<",
                                    "next": ">",
                                    "last": ">>"
                                }
                            },
                            "ordering": true,
                            "searching": false,
                            "order": [[5, "asc"]]
                        });
                        $('#Table1 tbody').on('click', 'tr', function () {
                            var data = Table1.row(this).data();
                            if (data == null)
                                return;
                            thisTs.ShowDetails(data);
                            $('#dlgDetails').modal();
                        });
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.onSearch2Change = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if ($("#Search2").val().length == 13) {
                    this.CreateTable2();
                }
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.CreateTable2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs, SearchText, data, _a, data, Table2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        thisTs = this;
                        SearchText = $("#Search2").val();
                        if (!(SearchText == null || SearchText == "")) return [3 /*break*/, 1];
                        // if (this.Role.dpa_access_approve) {
                        //   let data: any = await this.Api.get("crmservice", "searchApprovalTicket", "approvalstatuscode=03");
                        //   this.DataSource2 = data;
                        //   data = await this.Api.get("crmservice", "searchApprovalTicket", "approvalstatuscode=05");
                        //   data.forEach((a: any) => {
                        //     this.DataSource2.push(a);
                        //   });
                        // }
                        // else {
                        this.DataSource2 = [];
                        return [3 /*break*/, 6];
                    case 1:
                        if (!this.Role.dpa_access_approve) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=03")];
                    case 2:
                        data = _b.sent();
                        this.DataSource2 = data;
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=05")];
                    case 3:
                        data = _b.sent();
                        data.forEach(function (a) {
                            _this.DataSource2.push(a);
                        });
                        return [3 /*break*/, 6];
                    case 4:
                        _a = this;
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText)];
                    case 5:
                        _a.DataSource2 = _b.sent();
                        if (this.DataSource2.length > 0) {
                            data = this.DataSource2;
                            data.forEach(function (a) {
                                if (a.dpa_approvalstatuscode == '01')
                                    _this.DataSource2 = _this.DataSource2.filter(function (b) { return b.dpa_approvalticketid != a.dpa_approvalticketid; });
                            });
                        }
                        _b.label = 6;
                    case 6:
                        Table2 = $('#Table2').DataTable();
                        Table2.destroy();
                        Table2 = $('#Table2').DataTable({
                            "data": thisTs.DataSource2,
                            "columns": [
                                { "data": "dpa_name" },
                                {
                                    "data": "dpa_contactid",
                                    "render": function (data, type, row) {
                                        return row.dpa_authorizedperson == null ? row.dpa_contactidname : row.dpa_authorizedperson;
                                    }
                                },
                                {
                                    "data": "dpa_contactidname",
                                    "render": function (data, type, row) {
                                        return row.dpa_authorizedperson == null ? "" : row.dpa_contactidname;
                                    }
                                },
                                {
                                    "data": "dpa_originalsource",
                                    "render": function (data, type, row) {
                                        if (row.dpa_originalsource == 1)
                                            return "Customer Portal";
                                        else
                                            return "Agent Bank";
                                    }
                                },
                                {
                                    "data": "dpa_approvalstatusidname",
                                    "render": function (data, type, row) {
                                        return row.dpa_approvalstatusidname;
                                    }
                                },
                                {
                                    "data": "dpa_submitdate",
                                    "render": function (data, type, row) {
                                        if (row.dpa_submitdate != null) {
                                            var d = new Date(row.dpa_submitdate);
                                            return '<span class="sr-only">' + d.getFullYear().toString() + (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1).toString() + (d.getDate() < 10 ? "0" : "") + d.getDate().toString() + '</span>' +
                                                thisTs.Util.ConvertToBE(d.getDate().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString());
                                        }
                                        else
                                            return "";
                                    }
                                }
                            ],
                            "language": {
                                "lengthMenu": "แสดง _MENU_ รายการ/หน้า",
                                "zeroRecords": "ไม่มีข้อมูล",
                                "search": "ค้นหา:",
                                "info": "แสดงรายการที่ _START_ - _END_ จากทั้งหมด _TOTAL_ รายการ",
                                "infoEmpty": "ไม่มีข้อมูล",
                                "infoFiltered": "(ค้นหาจากทั้งหมด _MAX_ รายการ)",
                                "paginate": {
                                    "previous": "<",
                                    "first": "<<",
                                    "next": ">",
                                    "last": ">>"
                                }
                            },
                            "ordering": true,
                            "searching": false,
                            "order": [[5, "asc"]]
                        });
                        $('#Table2 tbody').on('click', 'tr', function () {
                            var data = Table2.row(this).data();
                            if (data == null)
                                return;
                            thisTs.ShowDetails(data);
                            $('#dlgDetails').modal();
                        });
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.ShowDetails = function (Rec) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs, Name, Name;
            return __generator(this, function (_a) {
                this.Util.ShowWaiting(true);
                this.Ticket = Rec;
                thisTs = this;
                this.CompanyTypeList = JSON.parse(localStorage.getItem("companyType"));
                this.PersonTypeList = JSON.parse(localStorage.getItem("personalType"));
                $('#TicketNo').val(this.Ticket.dpa_name);
                if (this.Ticket.dpa_personaltypeid != null && this.Ticket.dpa_personaltypeid != "" &&
                    this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == _this.Ticket.dpa_personaltypeid; }) != null) {
                    this.Type = CustomerType.Person;
                    $('#CustomerType').val(this.Ticket.dpa_personaltypeidname);
                    $('#divPerson').removeClass("hidden");
                    $('#divCompany').addClass("hidden");
                    if (this.Ticket.dpa_personaltypeidname.includes("ต่างชาติ")) {
                        $('#IDCardNo').html("เลขพาสปอร์ต");
                        $('#CitizenID2').val(this.Ticket.dpa_passport);
                    }
                    else {
                        $('#IDCardNo').html("เลขบัตรประชาชน");
                        $('#CitizenID2').val(this.Ticket.dpa_idcard);
                    }
                    Name = this.Ticket.dpa_contactidname.split(" ");
                    $('#FirstName2').val(Name[0]);
                    $('#LastName2').val(Name[1]);
                }
                else {
                    this.Type = CustomerType.Company;
                    $('#CustomerType').val(this.Ticket.dpa_companytypeidname);
                    $('#divPerson').addClass("hidden");
                    $('#divCompany').removeClass("hidden");
                    $('#CompanyName').val(this.Ticket.dpa_contactidname);
                    $('#RegistrationID').val(this.Ticket.dpa_registrationid);
                    if (this.Ticket.dpa_authorizedperson == null || this.Ticket.dpa_authorizedperson == "") {
                        $('#FirstName1').val("");
                        $('#LastName1').val("");
                    }
                    else {
                        Name = this.Ticket.dpa_authorizedperson.split(" ");
                        $('#FirstName1').val(Name[0]);
                        $('#LastName1').val(Name[1]);
                    }
                    $("#CitizenID1").val(this.Ticket.dpa_authorizedperson_idcard);
                }
                $("#Remark").val(this.Ticket.dpa_remark);
                this.Editable = true;
                $("#divButtonRecreate").addClass("hidden");
                $("#divRemark").attr("disabled", "disabled");
                if (this.Ticket.dpa_approvalstatuscode == '01') {
                    $("#PhoneNo").text(this.Ticket.telephone1 == null ? "" : this.Ticket.telephone1);
                    $("#OTP").val("");
                    $("#divOTP").removeClass("hidden");
                    $("#divDocList").attr("disabled", "disabled");
                    $("#divUpload").attr("disabled", "disabled");
                    $("#divUpload").removeClass("hidden");
                    $("#divFiles").attr("disabled", "disabled");
                    $("#divButtons").attr("disabled", "disabled");
                    $("#divButtons").removeClass("hidden");
                    // await this.RequestOTP();
                }
                else {
                    $("#divOTP").addClass("hidden");
                    $("#divDocList").removeAttr("disabled");
                    $("#divUpload").removeClass("hidden");
                    $("#divUpload").removeAttr("disabled");
                    $("#divFiles").removeAttr("disabled");
                    $("#divButtons").removeAttr("disabled");
                    $("#divButtons").removeClass("hidden");
                    if (this.Ticket.dpa_approvalstatuscode == '02') {
                        // if (this.Role.dpa_access_approve) {
                        $("#divUpload").addClass("hidden");
                        $("#divDocList").attr("disabled", "disabled");
                        this.Editable = false;
                        // }
                        // else
                        if (!this.Role.dpa_access_approve) {
                            $("#divButtons").addClass("hidden");
                        }
                        else {
                            $("#divRemark").removeAttr("disabled");
                        }
                    }
                }
                if (this.Ticket.dpa_approvalstatuscode == '03' || this.Ticket.dpa_approvalstatuscode == '05' || this.Ticket.dpa_approvalstatuscode == '06') {
                    $("#divDocList").attr("disabled", "disabled");
                    $("#divUpload").addClass("hidden");
                    // $("#divRemark").attr("disabled", "disabled");
                    //if (this.Ticket.dpa_code == 3 || this.Ticket.dpa_code == 5)
                    //$("#divButtons").attr("disabled", "disabled");
                    $("#divButtons").addClass("hidden");
                    this.Editable = false;
                    if (this.Ticket.dpa_approvalstatuscode == '06' && (this.Role.dpa_access_approve == null || this.Role.dpa_access_approve == false)) {
                        $("#divButtonRecreate").removeClass("hidden");
                        $("#btnRecreate").html("อัปโหลดเอกสาร");
                    }
                }
                this.Ticket.attachfilelist.forEach(function (a) {
                    var Decoded = atob(a.documentbody);
                    a.filesize = Decoded.length;
                    a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
                });
                this.FileList = this.Ticket.attachfilelist;
                this.CreateTableFile();
                this.CreateDocumentList();
                $('.docCheck').on("change", function (e) {
                    thisTs.SelectDocument(e.target);
                });
                this.Util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.CreateDocumentList = function () {
        var _this = this;
        var DocList;
        $("#divDocList").empty();
        if (this.Type == CustomerType.Person) {
            if (this.Ticket.dpa_personaltypeid == null) {
                return;
            }
            DocList = this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == _this.Ticket.dpa_personaltypeid; })[0].dpa_documentgrouplist;
        }
        else {
            if (this.Ticket.dpa_companytypeid == null) {
                return;
            }
            DocList = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == _this.Ticket.dpa_companytypeid; })[0].dpa_documentgrouplist;
        }
        this.DocumentList = [];
        if (this.Ticket.dpa_documentchecklist != null && this.Ticket.dpa_documentchecklist != "") {
            var Selected = this.Ticket.dpa_documentchecklist.split("|");
            for (var i = 0; i < Selected.length; i++) {
                this.DocumentList.push({
                    "dpa_documentid": Selected[i]
                });
            }
        }
        var DivContent = '<br />';
        var SeqNo = 1;
        var Checked = "";
        // DocList.forEach((DocGroup: any) => {
        //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
        //     Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(Doc.dpa_documentid) ? " checked" : "";
        //     DivContent += '<label class="checktable">';
        //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"' + Checked + '><span class="checkmark"></span>';
        //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
        //     DivContent += '</label>';
        //     SeqNo++;
        //   });
        // });
        DocList.forEach(function (DocGroup) {
            Checked = _this.DocumentList.length == 0 ? "" : _this.Ticket.dpa_documentchecklist.includes(DocGroup.dpa_documentgroupid) ? " checked" : "";
            DivContent += '<label class="checktable">';
            DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"' + Checked + '><span class="checkmark"></span>';
            DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
            DivContent += '</label>';
            SeqNo++;
        });
        $("#divDocList").append(DivContent);
    };
    TicketListComponent.prototype.SelectDocument = function (target) {
        if (target.checked) {
            if (this.DocumentList == null || this.DocumentList == undefined)
                this.DocumentList = [];
            this.DocumentList.push({
                "dpa_documentid": target.value,
            });
        }
        else {
            this.DocumentList = this.DocumentList.filter(function (a) { return a.dpa_documentid != target.value; });
        }
    };
    TicketListComponent.prototype.CreateTableFile = function () {
        var thisTs = this;
        var TableDocs = $('#TableDocs').DataTable({
            "paging": false,
            "bFilter": false,
            "info": false,
            "data": thisTs.FileList,
            "columns": [
                { "data": "filename", "class": "text-center" },
                { "data": "filename" },
                {
                    "data": "filesize",
                    "render": function (data, type, row) {
                        if (row.filesize / 1024 / 1024 < 1) {
                            return Math.floor(row.filesize / 1024) + ' KB';
                        }
                        else {
                            return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
                        }
                    },
                    "class": "text-right"
                },
                {
                    "data": null,
                    "render": function (data, type, row) {
                        return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
                            (thisTs.Editable ? '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" annotationid="' + row.annotationid + '" title="Delete"></i>' : '');
                    },
                    "class": "col-btn-2 text-center"
                }
            ],
            "language": {
                "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
            }
        });
        TableDocs.on('order.dt search.dt', function () {
            TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
            });
        }).destroy().draw();
    };
    TicketListComponent.prototype.BackToHome = function (ReloadTable) {
        return __awaiter(this, void 0, void 0, function () {
            var Table1, Table2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //if (ReloadTable) {
                        $('#Search1').val('');
                        $('#Search2').val('');
                        Table1 = $('#Table1').DataTable();
                        Table2 = $('#Table2').DataTable();
                        Table1.destroy();
                        Table2.destroy();
                        return [4 /*yield*/, this.CreateTable1()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.CreateTable2()];
                    case 2:
                        _a.sent();
                        //}
                        setTimeout(function () {
                            $('#btnCloseDlg').click();
                        }, 200);
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.ViewDoc = function (Url, FileName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Url == "") {
                    this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
                    return [2 /*return*/];
                }
                window.open(this.Util.CreateBlobUrl(Url), "_blank");
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.DeleteDoc = function (FileName, AnnotationID) {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        return [4 /*yield*/, this.Util.ConfirmDialog("คุณต้องการลบไฟล์เอกสารแนบใช่หรือไม่?")];
                    case 1:
                        _a.sent();
                        $("#btnMainConfirm").off('click');
                        $("#btnMainConfirm").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var DelObj;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(AnnotationID != null && AnnotationID != "" && AnnotationID != "null")) return [3 /*break*/, 2];
                                            DelObj = {
                                                annotationid: AnnotationID
                                            };
                                            return [4 /*yield*/, thisTs.Api.post("crmservice", "delAnnotation2", DelObj)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            thisTs.FileList.forEach(function (item, index) {
                                                if (item["filename"] === FileName)
                                                    thisTs.FileList.splice(index, 1);
                                            });
                                            thisTs.TotalFileSize = 0;
                                            thisTs.Ticket.attachfilelist.forEach(function (a) {
                                                var Decoded = atob(a.documentbody);
                                                a.filesize = Decoded.length;
                                                thisTs.TotalFileSize += a.filesize;
                                            });
                                            thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
                                            thisTs.CreateTableFile();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.FileSelect = function (File) {
        return __awaiter(this, void 0, void 0, function () {
            var FileName, FileExtension, TotalFileSize, FR, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                if (File.length == 0)
                    return [2 /*return*/];
                FileName = File[0]["name"];
                FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);
                if (!this.AcceptExtension.includes(FileExtension.toLowerCase())) {
                    this.Util.ErrorDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                TotalFileSize = File[0]["size"];
                this.FileList.forEach(function (a) {
                    TotalFileSize += +a["filesize"];
                });
                if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
                    this.Util.ErrorDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == File[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                FR = new FileReader();
                thisTs = this;
                FR.onload = function (e) {
                    var t = e.target;
                    FileContent = t.result;
                    MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                    var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                    if (thisTs.FileList == null || thisTs.FileList == undefined)
                        thisTs.FileList = [];
                    thisTs.FileList.push({
                        "annotationid": null,
                        "filename": File[0].name,
                        "documentbody": FileContent2,
                        "mimetype": MimeType,
                        "filesize": File[0]["size"],
                        "url": FileContent
                    });
                    $('#fileAttach').val('');
                    // $('#txtFileName').val('');
                    thisTs.CreateTableFile();
                };
                FR.readAsDataURL(File[0]);
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.UploadFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var FileInput, File, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                FileInput = $('#fileAttach')[0]["files"];
                if (FileInput.length == 0) {
                    this.Util.ErrorDialog('กรุณาเลือกไฟล์');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == FileInput[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                File = new FileReader();
                thisTs = this;
                File.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var t, FileContent2, T;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                t = e.target;
                                FileContent = t.result;
                                MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                                FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                                if (thisTs.FileList == null || thisTs.FileList == undefined)
                                    thisTs.FileList = [];
                                thisTs.FileList.push({
                                    "annotationid": null,
                                    "filename": FileInput[0].name,
                                    "documentbody": FileContent2,
                                    "mimetype": MimeType,
                                    "filesize": FileInput[0]["size"],
                                    "url": FileContent
                                });
                                $('#fileAttach').val('');
                                $('#txtFileName').val('');
                                if (!(thisTs.Ticket.dpa_approvalstatuscode == '02')) return [3 /*break*/, 3];
                                thisTs.Ticket.attachfilelist = thisTs.FileList;
                                return [4 /*yield*/, thisTs.Api.post("crmservice", "approvalticket", thisTs.Ticket)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, thisTs.Api.get("crmservice", "searchapprovalticket", "ticketno=" + thisTs.Ticket.dpa_name)];
                            case 2:
                                T = _a.sent();
                                thisTs.Ticket = T[0];
                                thisTs.Ticket.attachfilelist.forEach(function (a) {
                                    var Decoded = atob(a.documentbody);
                                    a.filesize = Decoded.length;
                                    a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
                                });
                                thisTs.FileList = thisTs.Ticket.attachfilelist;
                                _a.label = 3;
                            case 3:
                                thisTs.CreateTableFile();
                                return [2 /*return*/];
                        }
                    });
                }); };
                File.readAsDataURL(FileInput[0]);
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.UpdateStatus = function (Approve) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var DocGroup, thisTs, IsValid, Remark_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.FileList.length == 0) {
                            this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
                            return [2 /*return*/];
                        }
                        if (this.Type == CustomerType.Company) {
                            DocGroup = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == _this.Ticket.dpa_companytypeid; })[0].dpa_documentgrouplist;
                        }
                        else {
                            DocGroup = this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == _this.Ticket.dpa_personaltypeid; })[0].dpa_documentgrouplist;
                        }
                        this.Ticket.dpa_submitdate = this.Ticket.dpa_submitdate;
                        this.Ticket.dpa_documentchecklist = "";
                        this.DocumentList.forEach(function (a) {
                            _this.Ticket.dpa_documentchecklist += (_this.Ticket.dpa_documentchecklist == "" ? "" : "|") + a.dpa_documentid;
                        });
                        thisTs = this;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!Approve) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup)];
                    case 2:
                        IsValid = _a.sent();
                        if (!IsValid)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.Util.ConfirmDialog("ยืนยันอนุมัติรายการ?")];
                    case 3:
                        _a.sent();
                        $("#btnMainConfirm").off('click');
                        $("#btnMainConfirm").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var TicketNo;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            //thisTs.Ticket.dpa_code = 2;
                                            thisTs.Ticket.attachfilelist = thisTs.FileList;
                                            thisTs.TotalFileSize = 0;
                                            thisTs.Ticket.attachfilelist.forEach(function (a) {
                                                var Decoded = atob(a.documentbody);
                                                a.filesize = Decoded.length;
                                                thisTs.TotalFileSize += a.filesize;
                                                a.url = "";
                                            });
                                            thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
                                            thisTs.Ticket.dpa_approvalstatuscode = thisTs.Role.dpa_access_approve ? '03' : '02';
                                            thisTs.Ticket.dpa_remark = $("#Remark").val();
                                            thisTs.Ticket.dpa_approvalstatusid = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode);
                                            return [4 /*yield*/, thisTs.Api.post("crmservice", "approvalTicket", thisTs.Ticket)];
                                        case 1:
                                            TicketNo = _a.sent();
                                            if (!(thisTs.Ticket.dpa_approvalstatuscode == '03')) return [3 /*break*/, 3];
                                            return [4 /*yield*/, thisTs.InformStatus(thisTs.Ticket.dpa_approvalstatuscode)];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3:
                                            thisTs.Util.SuccessDialog("บันทึกสำเร็จ");
                                            return [4 /*yield*/, thisTs.BackToHome(true)];
                                        case 4:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [3 /*break*/, 6];
                    case 4:
                        Remark_1 = $("#Remark").val();
                        if (Remark_1 == null || Remark_1 == "") {
                            this.Util.WarningDialog("กรุณาระบุหมายเหตุ");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Util.ConfirmDialog("ยืนยันไม่อนุมัติรายการ?")];
                    case 5:
                        _a.sent();
                        $("#btnMainConfirm").off('click');
                        $("#btnMainConfirm").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var TicketNo;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            thisTs.Ticket.dpa_remark = Remark_1;
                                            //thisTs.Ticket.dpa_code = 6;
                                            thisTs.Ticket.dpa_approvalstatuscode = thisTs.Role.dpa_access_approve ? '05' : '06';
                                            thisTs.Ticket.attachfilelist = thisTs.FileList;
                                            thisTs.TotalFileSize = 0;
                                            thisTs.Ticket.attachfilelist.forEach(function (a) {
                                                var Decoded = atob(a.documentbody);
                                                a.filesize = Decoded.length;
                                                thisTs.TotalFileSize += a.filesize;
                                                a.url = "";
                                            });
                                            thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
                                            thisTs.Ticket.dpa_approvalstatusid = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode);
                                            return [4 /*yield*/, thisTs.Api.post("crmservice", "approvalTicket", thisTs.Ticket)];
                                        case 1:
                                            TicketNo = _a.sent();
                                            return [4 /*yield*/, thisTs.InformStatus(thisTs.Ticket.dpa_approvalstatuscode)];
                                        case 2:
                                            _a.sent();
                                            thisTs.Util.SuccessDialog("บันทึกสำเร็จ");
                                            return [4 /*yield*/, thisTs.BackToHome(true)];
                                        case 3:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        this.Util.ErrorDialog("บันทึกไม่สำเร็จ");
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.InformStatus = function (Status) {
        return __awaiter(this, void 0, void 0, function () {
            var Contact, MailObj, MailContent, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Api.get("crmservice", "contact", "contactid=" + this.Ticket.dpa_contactid)];
                    case 1:
                        Contact = _a.sent();
                        MailObj = {
                            //dpa_emailaddress: Contact[0].emailaddress1,
                            dpa_name: this.Ticket.dpa_authorizedperson == null || this.Ticket.dpa_authorizedperson == "" ? this.Ticket.dpa_contactidname : this.Ticket.dpa_authorizedperson,
                            dpa_callby: 3,
                            dpa_agentbankuserid: localStorage.getItem("AgentBank_UserID"),
                            contactid: this.Ticket.dpa_contactid
                        };
                        MailContent = "เรียน คุณ" + MailObj.dpa_name + "<br /><br /> สถาบันคุ้มครองเงินฝากขอแจ้งสถานะการยืนยันตัวตนผ่าน Agent Bank " +
                            (Status == "03" ? "ได้รับการอนุมัติเรียบร้อยแล้ว" : ((Status == "05" ? "ไม่ผ่านการอนุมัติ เนื่องจาก" : "ไม่ผ่านการตรวจสอบ เนื่องจาก") + this.Ticket.dpa_remark)) + "<br />" +
                            "ท่านสามารถเข้าตรวจสอบข้อมูลสถานะการจ่ายคืนเงินฝากผ่านระบบออนไลน์ได้ที่ Link  <br /><br />" +
                            "ขอแสดงความนับถือ <br />" +
                            "สถาบันคุ้มครองเงินฝาก <br />" +
                            "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                            "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                            "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                            "โทร : 02-272-0300";
                        MailObj.dpa_description = MailContent;
                        return [4 /*yield*/, this.Api.postPortal("crm", "informStatus", MailObj)];
                    case 2:
                        Res = _a.sent();
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    TicketListComponent.prototype.SubmitOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ParamObj, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($("#OTP").val() == "") {
                            this.Util.WarningDialog("กรุณาระบุรหัส OTP");
                            return [2 /*return*/];
                        }
                        ParamObj = {
                            OTP: $("#OTP").val(),
                            RefCode: this.OTPRefCode,
                            MobileNo: this.Contact.telephone1
                        };
                        return [4 /*yield*/, this.Api.postPortal("Crm", "VerifyOTP", ParamObj)];
                    case 1:
                        Res = _a.sent();
                        if (Res.IsValid == null || Res.IsValid == undefined) {
                            this.Util.WarningDialog("เกิดข้อผิดพลาดระหว่างตรวจสอบ OTP กรุณาติดต่อผู้ดูแลระบบ");
                            return [2 /*return*/];
                        }
                        if (Res.IsValid == false) {
                            this.Util.WarningDialog("รหัส OTP ไม่ถูกต้อง");
                            return [2 /*return*/];
                        }
                        $("#divOTP").addClass("hidden");
                        $("#divDocList").removeAttr("disabled");
                        $("#divUpload").removeAttr("disabled");
                        $("#divFiles").removeAttr("disabled");
                        $("#divRemark").removeAttr("disabled");
                        $("#divButtons").removeAttr("disabled");
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.CancelSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                $("#SearchFirstName").val("");
                $("#SearchLastName").val("");
                $("#SearchIdCard").val("");
                $("#SearchPassport").val("");
                this.CreateTable1();
                return [2 /*return*/];
            });
        });
    };
    TicketListComponent.prototype.RecreateTicket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs_1, DocGroup, IsValid, DocList, Res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.Editable) {
                            this.Editable = true;
                            $("#divButtonRecreate").removeClass("hidden");
                            $("#btnRecreate").html("ส่งข้อมูล");
                            $("#divDocList").removeAttr("disabled");
                            $("#divUpload").removeClass("hidden");
                            $("#divUpload").removeAttr("disabled");
                            $("#divFiles").removeAttr("disabled");
                            $("#divRemark").removeAttr("disabled");
                            $("#Remark").val("");
                            this.FileList = [];
                            this.Ticket.attachfilelist = [];
                            this.Ticket.dpa_documentchecklist = "";
                            thisTs_1 = this;
                            this.CreateDocumentList();
                            $('.docCheck').on("change", function (e) {
                                thisTs_1.SelectDocument(e.target);
                            });
                            this.CreateTableFile();
                            return [2 /*return*/];
                        }
                        if (this.FileList.length == 0) {
                            this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
                            return [2 /*return*/];
                        }
                        if (this.Type == CustomerType.Company) {
                            DocGroup = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == _this.Ticket.dpa_companytypeid; })[0].dpa_documentgrouplist;
                        }
                        else {
                            DocGroup = this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == _this.Ticket.dpa_personaltypeid; })[0].dpa_documentgrouplist;
                        }
                        return [4 /*yield*/, this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup)];
                    case 1:
                        IsValid = _a.sent();
                        if (!IsValid) {
                            return [2 /*return*/];
                        }
                        this.Util.ShowWaiting(true);
                        this.Ticket.dpa_approvalstatuscode = '02';
                        this.Ticket.dpa_approvalticketid = null;
                        this.Ticket.dpa_name = null;
                        this.Ticket.dpa_originalsource = 2;
                        this.Ticket.dpa_remark = $("#Remark").val();
                        this.Ticket.dpa_submitdate = new Date();
                        DocList = "";
                        this.DocumentList.forEach(function (a) {
                            DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
                        });
                        this.Ticket.attachfilelist = this.FileList;
                        this.Ticket.dpa_documentchecklist = DocList;
                        this.TotalFileSize = 0;
                        this.Ticket.attachfilelist.forEach(function (a) {
                            var Decoded = atob(a.documentbody);
                            a.filesize = Decoded.length;
                            _this.TotalFileSize += a.filesize;
                            a.url = "";
                        });
                        this.Ticket.dpa_attachsizing = this.TotalFileSize;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        this.Ticket.dpa_approvalstatusid = this.GetStatusGuidByCode(this.Ticket.dpa_approvalstatuscode);
                        return [4 /*yield*/, this.Api.post('crmservice', 'approvalticket', this.Ticket)];
                    case 3:
                        Res = _a.sent();
                        this.Util.ShowWaiting(false);
                        if (!(Res.dpa_name != null && Res.dpa_name != "")) return [3 /*break*/, 5];
                        this.Util.SuccessDialog("บันทึกข้อมูลสำเร็จ เลขรับเรื่องคือ " + Res.dpa_name);
                        return [4 /*yield*/, this.BackToHome(true)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ");
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        this.Util.ShowWaiting(false);
                        this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ");
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.RequestOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, ParamObj, Res, Msg, SmsRes, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.Api.get("crmservice", "contact", "contactid=" + this.Ticket.dpa_contactid)];
                    case 1:
                        _a.Contact = _b.sent();
                        this.Contact = this.Contact[0];
                        ParamObj = {
                            MobileNo: this.Contact.telephone1
                        };
                        return [4 /*yield*/, this.Api.postPortal("Crm", "RequestOTP", ParamObj)];
                    case 2:
                        Res = _b.sent();
                        if (Res.otpNo != null && Res.otpNo != undefined) {
                            this.OTPRefCode = Res.RefCode;
                            console.log(Res.otpNo);
                            $("#OTPRefCode").html(Res.RefCode);
                            Msg = "รหัสตรวจสอบการยืนยันตัวตนผ่านตัวแทนธนาคารของคุณคือ : ";
                            Msg += Res.otpNo + " ";
                            Msg += "(RefCode : " + Res.RefCode;
                            Msg += "(รหัสมีอายุ " + Res.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                            ParamObj = {
                                dpa_phoneno: this.Contact.telephone1,
                                dpa_description: Msg
                            };
                            SmsRes = this.Api.post("crmservice", "sendSms", ParamObj);
                            $("#btnSubmitOTP").removeAttr("disabled");
                            if (Res.expInMinute == undefined || Res.expInMinute == null) {
                                this.TotalTime = 300;
                            }
                            else {
                                this.TotalTime = Res.expInMinute * 60;
                            }
                            this.ElapseTime = 0;
                            if (this.SubScr != undefined) {
                                this.SubScr.unsubscribe();
                            }
                            this.SubScr = timer(0, 1000).subscribe(function () { return _this.CountDownOTP(); });
                            this.WaitTime = 60;
                            $("#btnRequestOTP").attr("disabled", "disabled");
                            if (this.SubScr2 != undefined) {
                                this.SubScr2.unsubscribe();
                            }
                            this.SubScr2 = timer(0, 1000).subscribe(function () { return _this.CountDownWaitTime(); });
                        }
                        else {
                            $("#btnSubmitOTP").attr("disabled", "disabled");
                            this.Util.ShowWaiting(false);
                            this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _b.sent();
                        $("#btnSubmitOTP").attr("disabled", "disabled");
                        this.Util.ShowWaiting(false);
                        this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TicketListComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            $("#btnSubmitOTP").attr("disabled", "disabled");
            $("#btnSubmitOTP").html("ยืนยัน");
            this.ElapseTime = 0;
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
    };
    TicketListComponent.prototype.CountDownWaitTime = function () {
        if (this.WaitTime == 0) {
            $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
            $("#btnRequestOTP").removeAttr("disabled");
            this.SubScr2.unsubscribe();
            return;
        }
        this.WaitTime--;
        $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
    };
    TicketListComponent.prototype.GetApprovalName = function (code) {
        var status = this.masterStatus.filter(function (s) {
            return s.dpa_code == code;
        });
        if (status != null && status.length > 0) {
            return status[0].dpa_name;
        }
        else {
            return "";
        }
    };
    TicketListComponent.prototype.GetStatusGuidByCode = function (code) {
        var found = this.masterStatus.filter(function (s) {
            return s.dpa_code == code;
        });
        if (found != null && found.length > 0) {
            return found[0].dpa_approvalstatusid;
        }
        else {
            return null;
        }
    };
    return TicketListComponent;
}());
export { TicketListComponent };



// WEBPACK FOOTER //
// ./src/app/ticket/ticket-list/ticket-list.component.ts.pre-build-optimizer.js